import React from "react";
import isFQDN from "validator/lib/isFQDN";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import PasswordGenerator from "Components/PasswordGenerator";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import QboxmailApi from "../../../qboxmailApi";
import { pwdCheck } from "Utils/strings";
import t from "Utils/translation";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import WarningBanner from "Components/warningBanner/WarningBanner";
import Select from "Components/select/Select";
import { tzs, getPanelLangs } from "@/config.js";

import cx from "classnames";

export default class BasicForm extends React.Component {
  state = {
    showAdvancedFields: false,
  };

  componentDidMount() {
    this.firstInput.focus();
  }

  submit = (e) => {
    e.preventDefault();
    this.props.submitForm();
  };

  toggleAdvancedFields = () => {
    this.setState({ showAdvancedFields: !this.state.showAdvancedFields });
  };

  goToNextStep = (e) => {
    const { setFormLoading, setFormErrors, setDataForm, goToStep, formData, isLoggedUserAdmin } = this.props;

    e.preventDefault();
    setFormLoading();

    this.validate(formData, isLoggedUserAdmin).then((errors) => {
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
      } else {
        setDataForm(this.state.formData);
        goToStep(3);
      }
    });
  };

  validate = async (
    { postmaster_password, name, company, postmaster_password_confirmation, customer_code },
    isLoggedUserAdmin
  ) => {
    let errors = {};
    if (!isFQDN(name)) errors.name = t("errorMsg.notValid.domain");

    const pwErrors = pwdCheck(postmaster_password);
    if (pwErrors) errors.postmaster_password = pwErrors;
    if (postmaster_password !== postmaster_password_confirmation) {
      errors.postmaster_password_confirmation = t("errorMsg.notMarch.passowrd");
    }
    if (!postmaster_password) errors.postmaster_password = t("errorMsg.missing.field");
    if (!postmaster_password_confirmation) errors.postmaster_password_confirmation = t("errorMsg.missing.field");
    if (!name) errors.name = t("errorMsg.missing.field");
    if (!customer_code && isLoggedUserAdmin) {
      errors.customer_code = t("errorMsg.missing.field");
    }

    if (this.props.loggedUser.orders?.[0]?.billing_cycle === "annually") {
      return errors;
    }

    const api = new QboxmailApi({ useCookie: true });
    let resp;
    try {
      resp = await api.validateDomainName(name);
      if (resp.valid) return errors;
      errors.name = resp.message;
      return errors;
    } catch (e) {
      console.error("qbpanel error:", e);
      errors.name = t("errorMsg.missing.field");
      return errors;
    }
  };

  getCustomers = (query) => {
    let client = new QboxmailApi({ useCookie: true });
    return client
      .getCustomers({ per: 10000, query })
      .then((data) => ({
        options: data.resources.map((res) => ({
          value: res.code,
          label: `${res.fullname} -  ${res.email_address}`,
        })),
      }))
      .catch((e) => {
        if (e instanceof Error) throw e;
      });
  };

  fillPasswordFields = (generatedPassword) => {
    this.props.setFormFieldValue({
      postmaster_password: generatedPassword,
      postmaster_password_confirmation: generatedPassword,
    });
  };

  setCustomerCode = (data) => {
    const customer = data.data;

    this.props.setFormFieldValue({
      customer_code: customer.code,
      timezone: customer.timezone,
      language: customer.language,
    });

    this.props.selectCustomer(customer);
  };

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading, isLoggedUserAdmin, loggedUser } = this.props;

    const { showAdvancedFields } = this.state;

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("domains.add.title.step2")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("domains.add.desc.step2")}</div>
            <Button className="btnDocsFP" docsKey="domains_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submit}>
            <div className="formsFP">
              {isLoggedUserAdmin && (
                <CustomerSelect
                  className="inputFull2"
                  label={t("input.label.customer")}
                  onChange={this.setCustomerCode}
                  errors={this.props.formErrors.customer_code}
                  initialValue={this.props.selectedCustomer?.code}
                />
              )}

              <Input
                className="inputFull2"
                name="name"
                label={t("input.label.domain.name")}
                placeholder={t("input.placeholder.domain.name")}
                ref={(input) => (this.firstInput = input)}
                type="text"
                value={formData.name}
                errors={formErrors.name}
                onChange={setFormFieldValue}
                trim
                autoComplete="new-password"
                autoCapitalize="off"
                disabled={loggedUser.orders?.[0]?.billing_cycle === "annually"}
                required
                helpTooltip={
                  <HelpTooltip
                    children={[
                      {
                        description: t("helpT.addDomain.domainName.step2"),
                      },
                    ]}
                  />
                }
              />

              <Input
                className={cx("inputFull2", {
                  inputAddMargin: formData.plan === "basic",
                })}
                name="company"
                label={t("input.label.domain.company")}
                placeholder={t("input.placeholder.company")}
                type="text"
                value={formData.company}
                errors={formErrors.company}
                onChange={setFormFieldValue}
                autoComplete="new-password"
              />

              {formData.plan !== "basic" && (
                <div
                  className={cx("internalLink", "inputFull2", {
                    inputAddMargin: !showAdvancedFields,
                  })}
                  onClick={this.toggleAdvancedFields}
                >
                  {showAdvancedFields ? t("button.advanced.domainInfo.hide") : t("button.advanced.domainInfo.show")}
                </div>
              )}

              {showAdvancedFields && (
                <Input
                  className="inputFull2"
                  name="telephone"
                  label={t("input.label.domain.telephone")}
                  placeholder={t("input.placeholder.telephone")}
                  type="text"
                  value={formData.telephone}
                  errors={formErrors.telephone}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  className="inputFull2"
                  name="address"
                  label={t("input.label.address")}
                  placeholder={t("input.placeholder.address")}
                  type="text"
                  value={formData.address}
                  errors={formErrors.address}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  name="zip"
                  label={t("input.label.postcode")}
                  placeholder={t("input.placeholder.postcode")}
                  type="text"
                  value={formData.zip}
                  errors={formErrors.zip}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  name="city"
                  label={t("input.label.city")}
                  placeholder={t("input.placeholder.city")}
                  type="text"
                  value={formData.city}
                  errors={formErrors.city}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  className={cx("inputAddMargin")}
                  name="state"
                  label={t("input.label.state")}
                  placeholder={t("input.placeholder.state")}
                  type="text"
                  value={formData.state}
                  errors={formErrors.state}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  className={cx("inputAddMargin")}
                  name="country"
                  label={t("input.label.country")}
                  placeholder={t("input.placeholder.country")}
                  type="text"
                  value={formData.country}
                  errors={formErrors.country}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              <Select
                className={cx("inputAddMargin")}
                label={t("input.label.language")}
                components={{ DropdownIndicator }}
                name="language"
                options={getPanelLangs()}
                onChange={setFormFieldValue}
                value={formData.language}
                clearable={false}
                isSearchable={false}
              />

              <Select
                className={cx("inputAddMargin")}
                label={t("input.label.timezone")}
                components={{ DropdownIndicator }}
                name="timezone"
                options={tzs}
                initialValue={loggedUser.timezone}
                clearable={false}
                onChange={setFormFieldValue}
                value={formData.timezone}
                isSearchable={false}
              />

              <Input
                className="inputFull2"
                name="postmaster_password"
                type="password"
                label={t("input.label.password.postmaster")}
                value={formData.postmaster_password}
                errors={formErrors.postmaster_password}
                onChange={setFormFieldValue}
                autoComplete="new-password"
                required
                helpTooltip={
                  <HelpTooltip
                    children={[
                      {
                        description: t("helpT.addDomain.postmasterPassword.step2"),
                      },
                    ]}
                  />
                }
              />
              <Input
                className="inputFull2"
                name="postmaster_password_confirmation"
                type="password"
                label={t("input.label.passwordConfirm.postmaster")}
                value={formData.postmaster_password_confirmation}
                errors={formErrors.postmaster_password_confirmation}
                onChange={setFormFieldValue}
                autoComplete="new-password"
                required
              />
              <PasswordGenerator
                className={cx("inputFull2", { inputAddMargin: isLoggedUserAdmin })}
                onNewPassword={this.fillPasswordFields}
              />
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" loading={isFormLoading} onClick={this.goToNextStep}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
